import React, { useState } from 'react';
import { Menu, X, MessageSquare, LayoutGrid, DollarSign, Home, Phone, Star, HelpCircle } from 'lucide-react';
import { trackWhatsAppClick } from '../services/adminStorage';

export default function Navbar({ activeTab, onNavigate }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleNav = (tab) => {
    onNavigate(tab);
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openWhatsApp = () => {
    trackWhatsAppClick();
    const text = encodeURIComponent('Olá! Vim pelo site da Suzume Technologies e gostaria de tirar dúvidas sobre a assinatura de modelos.');
    window.open(`https://wa.me/5511932654166?text=${text}`, '_blank');
  };

  return (
    <header className="navbar-header">
      <div className="container navbar-container">
        <div className="navbar-logo" onClick={() => handleNav('home')} style={{ cursor: 'pointer' }}>
          <img 
            src="/img/logo_suzume_horizontal.png" 
            alt="Suzume Technologies" 
            onError={(e) => {
              // Fallback se a imagem não carregar por algum motivo
              e.target.onerror = null;
              e.target.src = '/img/LogoSuzume.png';
            }} 
          />
        </div>

        <nav>
          <ul className={`navbar-links ${mobileOpen ? 'mobile-open' : ''}`}>
            <li 
              className={`navbar-link ${activeTab === 'home' ? 'active' : ''}`}
              onClick={() => handleNav('home')}
            >
              <Home size={16} inline="true" style={{ verticalAlign: 'middle', marginRight: 4 }} />
              Início
            </li>
            <li 
              className={`navbar-link ${activeTab === 'catalog' ? 'active' : ''}`}
              onClick={() => handleNav('catalog')}
            >
              <LayoutGrid size={16} inline="true" style={{ verticalAlign: 'middle', marginRight: 4 }} />
              Catálogo de Modelos
            </li>
            <li 
              className={`navbar-link ${activeTab === 'pricing' ? 'active' : ''}`}
              onClick={() => {
                if (activeTab !== 'home') {
                  onNavigate('home');
                  setTimeout(() => {
                    document.getElementById('pricing-section')?.scrollIntoView({ behavior: 'smooth' });
                  }, 100);
                } else {
                  document.getElementById('pricing-section')?.scrollIntoView({ behavior: 'smooth' });
                }
                setMobileOpen(false);
              }}
            >
              <DollarSign size={16} inline="true" style={{ verticalAlign: 'middle', marginRight: 4 }} />
              Planos & Preços
            </li>
            <li 
              className={`navbar-link ${activeTab === 'reviews' ? 'active' : ''}`}
              onClick={() => {
                if (activeTab !== 'home') {
                  onNavigate('home');
                  setTimeout(() => {
                    document.getElementById('reviews-section')?.scrollIntoView({ behavior: 'smooth' });
                  }, 100);
                } else {
                  document.getElementById('reviews-section')?.scrollIntoView({ behavior: 'smooth' });
                }
                setMobileOpen(false);
              }}
            >
              <Star size={16} inline="true" style={{ verticalAlign: 'middle', marginRight: 4 }} />
              Avaliações
            </li>
            <li 
              className={`navbar-link ${activeTab === 'faq' ? 'active' : ''}`}
              onClick={() => {
                if (activeTab !== 'home') {
                  onNavigate('home');
                  setTimeout(() => {
                    document.getElementById('faq-section')?.scrollIntoView({ behavior: 'smooth' });
                  }, 100);
                } else {
                  document.getElementById('faq-section')?.scrollIntoView({ behavior: 'smooth' });
                }
                setMobileOpen(false);
              }}
            >
              <HelpCircle size={16} inline="true" style={{ verticalAlign: 'middle', marginRight: 4 }} />
              Dúvidas
            </li>
            <li 
              className={`navbar-link ${activeTab === 'contact' ? 'active' : ''}`}
              onClick={() => handleNav('contact')}
            >
              <Phone size={16} inline="true" style={{ verticalAlign: 'middle', marginRight: 4 }} />
              Contato
            </li>
          </ul>
        </nav>

        <div className="navbar-actions">
          <button className="btn btn-whatsapp btn-sm" onClick={openWhatsApp}>
            <MessageSquare size={18} />
            <span className="hide-mobile">WhatsApp</span>
          </button>
          <button 
            className="mobile-menu-btn" 
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Abrir menu"
          >
            {mobileOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>
    </header>
  );
}
